var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c(
            "div",
            { staticClass: "flex flex-wrap items-center justify-between mb-4" },
            [
              _c("div", [
                _c("h4", { staticClass: "mb-1" }, [
                  _vm._v(_vm._s(_vm.$t("lesson.agenda.title"))),
                ]),
                _vm.lessonName
                  ? _c("div", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.lessonName)),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-1",
                      attrs: { variant: "outline-secondary", size: "sm" },
                      on: { click: _vm.goBack },
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "ArrowLeftIcon" },
                      }),
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v(_vm._s(_vm.$t("back"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-1",
                      attrs: { variant: "outline-primary", size: "sm" },
                      on: { click: _vm.previousWindow },
                    },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "ChevronLeftIcon" },
                      }),
                    ],
                    1
                  ),
                  _c("span", { staticClass: "font-medium mx-1" }, [
                    _vm._v(_vm._s(_vm.windowLabel)),
                  ]),
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-1",
                      attrs: { variant: "outline-primary", size: "sm" },
                      on: { click: _vm.nextWindow },
                    },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "ChevronRightIcon" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-primary", size: "sm" },
                      on: { click: _vm.goToday },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("lesson.agenda.today")) + " ")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm.visibleDays.length === 0
            ? _c("div", { staticClass: "text-center text-muted p-4" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("lesson.agenda.empty_window")) + " "
                ),
              ])
            : _vm._e(),
          _vm._l(_vm.visibleDays, function (day) {
            return _c(
              "div",
              { key: day.date, staticClass: "mb-3" },
              [
                _c(
                  "div",
                  { staticClass: "font-bold border-b pb-1 mb-2 capitalize" },
                  [_vm._v(" " + _vm._s(_vm.formatDayHeader(day)) + " ")]
                ),
                _vm._l(day.slots, function (slot, slotIndex) {
                  return _c(
                    "div",
                    {
                      key: day.date + "-" + slot.startTime + "-" + slotIndex,
                      staticClass: "border rounded p-2 mb-2",
                      class: { "opacity-75": slot.status === "CA" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-wrap items-center justify-between gap-2",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-2" },
                            [
                              _c("feather-icon", {
                                staticClass: "h-4 w-4 mr-1",
                                attrs: { icon: "ClockIcon" },
                              }),
                              _c("span", { staticClass: "font-medium mr-2" }, [
                                _vm._v(
                                  _vm._s(slot.startTime) +
                                    " - " +
                                    _vm._s(slot.endTime)
                                ),
                              ]),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.auto",
                                      value: {
                                        content: _vm.$t(
                                          "lesson.agenda.show_students"
                                        ),
                                        delay: { show: 500, hide: 100 },
                                      },
                                      expression:
                                        "{\n                content: $t('lesson.agenda.show_students'),\n                delay: { show: 500, hide: 100 },\n              }",
                                      modifiers: { auto: true },
                                    },
                                  ],
                                  staticClass: "cursor-pointer mr-2",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleStudents(
                                        day.date,
                                        slotIndex
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "h-4 w-4 mr-50",
                                    attrs: { icon: "UsersIcon" },
                                  }),
                                  _c("span", { staticClass: "font-bold" }, [
                                    _vm._v(
                                      _vm._s(slot.occupied) +
                                        "/" +
                                        _vm._s(
                                          slot.capacity === null
                                            ? "∞"
                                            : slot.capacity
                                        )
                                    ),
                                  ]),
                                  _vm.compositionLabel(slot)
                                    ? _c(
                                        "small",
                                        { staticClass: "text-muted ml-50" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.compositionLabel(slot))
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "vs-chip",
                                {
                                  staticClass: "mr-1",
                                  attrs: {
                                    color: _vm.capacitySourceColor(slot),
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.capacitySourceLabel(slot)) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "vs-chip",
                                { attrs: { color: _vm.statusColor(slot) } },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.statusLabel(slot)) + " "
                                  ),
                                ]
                              ),
                              slot.off_grid
                                ? _c(
                                    "vs-chip",
                                    {
                                      staticClass: "ml-1",
                                      attrs: { color: "dark" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("lesson.agenda.off_grid")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          !_vm.isPast(day.date) && slot.status !== "CA"
                            ? _c(
                                "div",
                                { staticClass: "flex items-center gap-2" },
                                [
                                  _c("feather-icon", {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: "lessons.edit",
                                        expression: "'lessons.edit'",
                                      },
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.auto",
                                        value: {
                                          content: _vm.$t(
                                            "lesson.agenda.adjust_capacity"
                                          ),
                                          delay: { show: 500, hide: 100 },
                                        },
                                        expression:
                                          "{ content: $t('lesson.agenda.adjust_capacity'), delay: { show: 500, hide: 100 } }",
                                        modifiers: { auto: true },
                                      },
                                    ],
                                    staticClass:
                                      "h-5 w-5 mr-1 stroke-current text-warning cursor-pointer",
                                    attrs: { icon: "EditIcon" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openAction(
                                          "capacity",
                                          day,
                                          slot
                                        )
                                      },
                                    },
                                  }),
                                  _c("feather-icon", {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: "lessons.edit",
                                        expression: "'lessons.edit'",
                                      },
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.auto",
                                        value: {
                                          content: slot.blocked
                                            ? _vm.$t("lesson.agenda.unblock")
                                            : _vm.$t("lesson.agenda.block"),
                                          delay: { show: 500, hide: 100 },
                                        },
                                        expression:
                                          "{\n                content: slot.blocked ? $t('lesson.agenda.unblock') : $t('lesson.agenda.block'),\n                delay: { show: 500, hide: 100 },\n              }",
                                        modifiers: { auto: true },
                                      },
                                    ],
                                    staticClass:
                                      "h-5 w-5 mr-1 stroke-current cursor-pointer",
                                    class: slot.blocked
                                      ? "text-success"
                                      : "text-dark",
                                    attrs: {
                                      icon: slot.blocked
                                        ? "UnlockIcon"
                                        : "LockIcon",
                                    },
                                    on: {
                                      click: function ($event) {
                                        slot.blocked
                                          ? _vm.removeOverride(slot)
                                          : _vm.openAction("block", day, slot)
                                      },
                                    },
                                  }),
                                  slot.override_id && !slot.blocked
                                    ? _c("feather-icon", {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName: "v-permission",
                                            value: "lessons.edit",
                                            expression: "'lessons.edit'",
                                          },
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip.auto",
                                            value: {
                                              content: _vm.$t(
                                                "lesson.agenda.reset_override"
                                              ),
                                              delay: { show: 500, hide: 100 },
                                            },
                                            expression:
                                              "{ content: $t('lesson.agenda.reset_override'), delay: { show: 500, hide: 100 } }",
                                            modifiers: { auto: true },
                                          },
                                        ],
                                        staticClass:
                                          "h-5 w-5 mr-1 stroke-current text-primary cursor-pointer",
                                        attrs: { icon: "RotateCcwIcon" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeOverride(slot)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _c("feather-icon", {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: "lessons.seat_grant",
                                        expression: "'lessons.seat_grant'",
                                      },
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.auto",
                                        value: {
                                          content: _vm.$t(
                                            "schedule_event.seat_grant"
                                          ),
                                          delay: { show: 500, hide: 100 },
                                        },
                                        expression:
                                          "{ content: $t('schedule_event.seat_grant'), delay: { show: 500, hide: 100 } }",
                                        modifiers: { auto: true },
                                      },
                                    ],
                                    staticClass:
                                      "h-5 w-5 mr-1 stroke-current text-success cursor-pointer",
                                    attrs: { icon: "UserPlusIcon" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openAction(
                                          "grant",
                                          day,
                                          slot
                                        )
                                      },
                                    },
                                  }),
                                  _c("feather-icon", {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: "cancellation_requests.edit",
                                        expression:
                                          "'cancellation_requests.edit'",
                                      },
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.auto",
                                        value: {
                                          content: _vm.$t(
                                            "lesson.agenda.cancel_occurrence"
                                          ),
                                          delay: { show: 500, hide: 100 },
                                        },
                                        expression:
                                          "{ content: $t('lesson.agenda.cancel_occurrence'), delay: { show: 500, hide: 100 } }",
                                        modifiers: { auto: true },
                                      },
                                    ],
                                    staticClass:
                                      "h-5 w-5 stroke-current text-danger cursor-pointer",
                                    attrs: { icon: "XCircleIcon" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openAction(
                                          "cancel",
                                          day,
                                          slot
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                      slot.reason
                        ? _c("div", { staticClass: "mt-1" }, [
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                _vm._s(_vm.$t("lesson.agenda.reason")) +
                                  ": " +
                                  _vm._s(slot.reason)
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.isExpanded(day.date, slotIndex)
                        ? _c(
                            "div",
                            { staticClass: "mt-2 border-t pt-2" },
                            [
                              slot.students.length === 0
                                ? _c("div", [
                                    _c("small", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("lesson.agenda.no_students")
                                        )
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._l(slot.students, function (student) {
                                return _c(
                                  "div",
                                  {
                                    key: student.scheduled_event_id,
                                    staticClass:
                                      "flex items-center justify-between py-50",
                                  },
                                  [
                                    _c("small", [
                                      _vm._v(_vm._s(student.name) + " "),
                                      _c(
                                        "span",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            "(" + _vm._s(student.email) + ")"
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "vs-chip",
                                      {
                                        staticClass: "ml-2",
                                        attrs: {
                                          color: _vm.originColor(
                                            student.origin
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              student.origin_label || "—"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              slot.seat_grants && slot.seat_grants.length
                                ? _c(
                                    "div",
                                    { staticClass: "mt-2 border-t pt-2" },
                                    [
                                      _c(
                                        "small",
                                        {
                                          staticClass:
                                            "text-muted d-block mb-1",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "lesson.agenda.seat_grants_title"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._l(
                                        slot.seat_grants,
                                        function (grant) {
                                          return _c(
                                            "div",
                                            {
                                              key: "grant-" + grant.id,
                                              staticClass:
                                                "flex items-center justify-between py-50",
                                            },
                                            [
                                              _c("small", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(grant.user_name) +
                                                    " "
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "text-muted" },
                                                  [
                                                    _vm._v(
                                                      "— " +
                                                        _vm._s(
                                                          grant.scope_label
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                grant.reason
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-muted",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "· " +
                                                            _vm._s(grant.reason)
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]),
                                              _c("feather-icon", {
                                                directives: [
                                                  {
                                                    name: "permission",
                                                    rawName: "v-permission",
                                                    value: "lessons.seat_grant",
                                                    expression:
                                                      "'lessons.seat_grant'",
                                                  },
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip.auto",
                                                    value: {
                                                      content: _vm.$t(
                                                        "lesson.agenda.revoke_seat_grant"
                                                      ),
                                                      delay: {
                                                        show: 500,
                                                        hide: 100,
                                                      },
                                                    },
                                                    expression:
                                                      "{ content: $t('lesson.agenda.revoke_seat_grant'), delay: { show: 500, hide: 100 } }",
                                                    modifiers: { auto: true },
                                                  },
                                                ],
                                                staticClass:
                                                  "h-4 w-4 stroke-current text-danger",
                                                staticStyle: {
                                                  cursor: "pointer",
                                                },
                                                attrs: { icon: "XIcon" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.confirmRevokeGrant(
                                                      grant
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  )
                }),
              ],
              2
            )
          }),
        ],
        2
      ),
      _c("occurrence-action-modal", {
        ref: "actionModal",
        attrs: { "lesson-id": _vm.lessonId, "lesson-name": _vm.lessonName },
        on: { saved: _vm.loadData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }